import { Component, Input, OnInit } from '@angular/core';
import { BlockActionType } from 'src/app/enums/block-action-type';
import { TextfieldType } from 'src/app/enums/textfield-type';
import {
  BlockAction,
  InputField,
  ZwWestnetzBlock,
} from 'src/app/models/block.model';
import { Page, Project } from 'src/app/models/project.model';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'app-details-zw-westnetz-items',
  templateUrl: './details-zw-westnetz-items.component.html',
  styleUrls: ['./details-zw-westnetz-items.component.scss'],
})
export class DetailsZwWestnetzItemsComponent implements OnInit {
  @Input() selectedWestnetzItem: InputField | null;
  selectedWestnetzItemType: string | null;
  selectedWestnetzItemIndex: number = -1;
  @Input() items: InputField[] = [];
  @Input() westnetz: any;

  @Input() submitButton: any;

  @Input() project: Project;

  actions: string[] = ['Nächste Seite', 'Andere Seite', 'Link'];

  pages: Page[] = [];
  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.pages = this.appService.state.editor.currentProject.pages;
  }

  openItem(inputField: InputField, index: number) {
    this.selectedWestnetzItemType = null;
    this.selectedWestnetzItem = inputField;
    this.selectedWestnetzItemIndex = index;
    this.appService.stateSubject.next({
      ...this.appService.state,

      editor: {
        ...this.appService.state.editor,
        layout: {
          ...this.appService.state.editor.layout,
          sideDetail: {
            ...this.appService.state.editor.layout.sideDetail,
            selectedInputField: inputField,
          },
        },
      },
    });
  }

  getActionTypeStringOnSuccess() {
    switch (this.westnetz.content.onSuccess.type) {
      case BlockActionType.NEXTPAGE: {
        return 'Nächste Seite';
      }
      case BlockActionType.CONNECTEDPAGE: {
        return 'Andere Seite';
      }
      case BlockActionType.LINK: {
        return 'Link';
      }
    }
    this.appService.setShouldSave(true);

    return '';
  }

  getActionTypeStringOnFail() {
    switch (this.westnetz.content.onFail.type) {
      case BlockActionType.NEXTPAGE: {
        return 'Nächste Seite';
      }
      case BlockActionType.CONNECTEDPAGE: {
        return 'Andere Seite';
      }
      case BlockActionType.LINK: {
        return 'Link';
      }
    }
    this.appService.setShouldSave(true);

    return '';
  }

  openButton() {
    this.selectedWestnetzItem = this.submitButton;
    this.selectedWestnetzItemType = 'submitButton';

    this.appService.stateSubject.next({
      ...this.appService.state,
      editor: {
        ...this.appService.state.editor,
        layout: {
          ...this.appService.state.editor.layout,
          sideDetail: {
            ...this.appService.state.editor.layout.sideDetail,
            selectedInputField: this.selectedWestnetzItem,
          },
        },
      },
    });
  }

  showWestnetz() {
    this.selectedWestnetzItem = null;
    this.appService.stateSubject.next({
      ...this.appService.state,
      editor: {
        ...this.appService.state.editor,
        layout: {
          ...this.appService.state.editor.layout,
          sideDetail: {
            ...this.appService.state.editor.layout.sideDetail,
            selectedInputField: this.selectedWestnetzItem,
          },
        },
      },
    });
  }

  showWestnetzItem() {
    let returnValue: boolean = false;

    if (this.selectedWestnetzItem || this.selectedWestnetzItem !== null) {
      returnValue = true;
    }

    return returnValue;
  }

  moveUp(index: number) {
    if (index > 0) {
      let item = this.items[index];
      this.items.splice(index, 1);
      this.items.splice(index - 1, 0, item);
    }
    this.appService.setShouldSave(true);
  }

  moveDown(index: number) {
    if (index < this.items.length - 1) {
      let item = this.items[index];
      this.items.splice(index, 1);
      this.items.splice(index + 1, 0, item);
    }
    this.appService.setShouldSave(true);
  }

  setOnSuccessAction(action: string) {
    console.log(action);
    switch (action) {
      case 'Nächste Seite':
        {
          const blockAction: BlockAction = {
            type: BlockActionType.NEXTPAGE,
          };
          this.westnetz.content.onSuccess = blockAction;
        }
        break;
      case 'Andere Seite':
        {
          const blockAction: BlockAction = {
            type: BlockActionType.CONNECTEDPAGE,
          };
          this.westnetz.content.onSuccess = blockAction;
        }
        break;
      case 'Link': {
        const blockAction: BlockAction = {
          type: BlockActionType.LINK,
        };
        this.westnetz.content.onSuccess = blockAction;

        break;
      }
    }
    this.appService.setShouldSave(true);
  }

  setOnFailAction(action: string) {
    console.log(action);
    switch (action) {
      case 'Nächste Seite':
        {
          const blockAction: BlockAction = {
            type: BlockActionType.NEXTPAGE,
          };
          this.westnetz.content.onFail = blockAction;
        }
        break;
      case 'Andere Seite':
        {
          const blockAction: BlockAction = {
            type: BlockActionType.CONNECTEDPAGE,
          };
          this.westnetz.content.onFail = blockAction;
        }
        break;
      case 'Link': {
        const blockAction: BlockAction = {
          type: BlockActionType.LINK,
        };
        this.westnetz.content.onFail = blockAction;

        break;
      }
    }
    this.appService.setShouldSave(true);
  }

  setConnectedPageOnSuccess(page: Page) {
    this.westnetz.content.onSuccess.connectedPage = page.id;

    this.appService.setShouldSave(true);
  }

  setConnectedPageOnFail(page: Page) {
    this.westnetz.content.onFail.connectedPage = page.id;

    this.appService.setShouldSave(true);
  }

  updateLinkOnSuccess(link: string) {
    this.westnetz.content.onSuccess.action.link = link;

    this.appService.setShouldSave(true);
  }

  updateLinkOnFail(link: string) {
    this.westnetz.content.onFail.action.link = link;

    this.appService.setShouldSave(true);
  }
}
